module.exports = __webpack_public_path__ + "media/hallBgm.96770910.mp3";